"use strict";

module.exports = require('./lib/Inflector');



//////////////////
// WEBPACK FOOTER
// ./node_modules/inflected/index.js
// module id = 1120
// module chunks = 0